import { Route, Routes } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { ActivateEmailComponent } from './activate-email/activate-email.component';
import { ActivateAccountComponent } from './activate-account/activate-account.component';
import { PAGE_TITLE_SUFFIX } from '../../app.constants';

export const activateEmailRoute: Route = {
  path: 'activate-email',
  component: ActivateEmailComponent,
  data: {
    needAuthentication: false,
    pageTitle: `Activation${PAGE_TITLE_SUFFIX}`
  },
  canActivate: [UserRouteAccessService]
};

export const activateAccountRoute: Routes = [
    {
        path: 'activate-account',
        component: ActivateAccountComponent,
        data: {
        needAuthentication: false,
        pageTitle: `Activation${PAGE_TITLE_SUFFIX}`
        },
        canActivate: [UserRouteAccessService]
  },
  {
        path: 'activate',
        component: ActivateAccountComponent,
        data: {
        needAuthentication: false,
        pageTitle: `Activation${PAGE_TITLE_SUFFIX}`
        },
        canActivate: [UserRouteAccessService]
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/activate/activate.route.ts